<template>
	<div>
		<div style="width: 100%;display: flex;">
			<div style="width: 29%;height: 400px;background: #ffffff;border-radius: 5px;margin-right: 1%;border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  5px -4px;">
				<div class="m-3">打印设置</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);margin-bottom: 20px;"></div>
				<div class="d-flex m-3" style="align-items: center;">
					<div style="font-size: 13px;color: #6f6f6f;margin-right: 10px;">选择报表</div>
					<el-button type="primary" @click="onSubmit" size="mini">销售发货单</el-button>
				</div>
			</div>
			<div style="width: 70%;height: 560px;background: #ffffff;border-radius: 5px;margin-right: 1%;border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  5px -4px;">
				<div class="m-3">打印预览</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);margin-bottom: 20px;"></div>
				<div id="printMe" style="width: 100%;height: 100%;">
					<div class="d-flex m-3" style="justify-content: center;font-size: 18px;font-weight: 800;">QKERP 销售报价单</div>
					<div style="width: 100%;" class="d-flex m-3">
						<div style="width: 50%;">
							<div style="font-size: 14px;">NO.T12156</div>
							<div style="font-size: 14px;">客户：又是我</div>
							<div style="font-size: 14px;">报价：158645</div>
							<div style="font-size: 14px;">下单时间：2022-08-23 19:18:26</div>
						</div>
						<div style="width: 50%;">
							<div style="font-size: 14px;">发货仓库：天河奥特曼仓库</div>
							<div style="font-size: 14px;">产品数量：48925</div>
							<div style="font-size: 14px;">打印时间：2022-08-23 19:18:26</div>
						</div>
					</div>
					<div class="m-3" style="width: 100%;">
						<el-table :data="tableData" border style="width: 96%" size="mini" :cell-style="cellStyle" :header-cell-style="{color:'black',borderColor:'black'}">
							<el-table-column prop="name" label="产品名称" width="180"></el-table-column>
							<el-table-column prop="gg" label="规格名称" width="180"></el-table-column>
							<el-table-column prop="dw" label="单位"></el-table-column>
							<el-table-column prop="num" label="数量"></el-table-column>
						</el-table>
					</div>
					<div style="width: 100%;" class="d-flex m-3">
						<div style="width: 50%;">
							<div style="font-size: 14px;">部门：公司总部</div>
							<div style="font-size: 14px;">职员：你是谁</div>
						</div>
						<div style="width: 50%;">
							<div style="font-size: 14px;">备注：很多很多雨</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="display: flex;justify-content: center;width: 100%;" class="px-2">
				<el-button type="primary" size="mini" v-print="'#printMe'">普通打印</el-button>
				<el-button type="info" @click="gotos('xsgl_ddcl_xsdd')">关闭窗口</el-button>
			</div>
		</el-footer>
	</div>
</template>

<script>
export default {
	data() {
		return {
			tableData: [
				{
					name: '文具礼盒套装',
					gg: '盲盒装',
					dw: '盒',
					num: 1563
				},
				{
					name: '油画棒',
					gg: '盲盒装',
					dw: '支',
					num: 1563
				}
			]
		};
	},
	methods: {
		//设置单元格背景
		cellStyle({ row, column, rowIndex, columnIndex }) {
			return 'height:35px!important; border-color:black!important; color:#000000!important; padding:0px!important; height:40px!important';
		},
		gotos(e) {
			this.$router.push({
				name: e
			});
		},
	}
};
</script>

<style>
/* .el-table td,
.el-table th.is-leaf,
.el-table--border,
.el-table--group {
	border-color: black;
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
	background-color: black;
} */
</style>
